import {
   getCoursesFromClient,
   GetCoursesRequestOptions,
} from '~/pages/api/courses/_shared/getCourses.api';
import { useIncrementalQuery } from '~/pages/_shared/useIncrementalQuery';

const KEY = 'courses';

export function getCoursesKey() {
   return [KEY];
}

export function useCourses(options?: GetCoursesRequestOptions) {
   return useIncrementalQuery([KEY, options], async page => {
      let { courses: data, hasMore } = await getCoursesFromClient({
         ...options,
         page,
      });

      return { page, data, hasMore };
   });
}
